export class Faq {
  public id: string;
  public question: string;
  public answer: string;
  public orderIndex: string;
  public translations: FaqTranslation[] = [];

  constructor(init?: Partial<Faq>) {
    Object.assign(this, init);

    if (init && init.translations) {
      this.translations = init.translations.map(t => new FaqTranslation(t));
    }
  }
}

export class FaqTranslation {
  public id: string;
  public culture: string;
  public question: string;
  public answer: string;

  constructor(init?: Partial<FaqTranslation>) {
    Object.assign(this, init);
  }
}
